module.exports = __webpack_public_path__ + "img/category_adventure.cc6d100.png";